import { z } from "@/zod";
import { POSTAL_CODE_REGEX } from "@/constants";
import { t } from "i18next";

export const city = z.string().min(1).max(100);
export const streetName = z.string().min(1).max(100);
export const streetNameOptional = z.string().max(100).optional();
export const streetNumber = z.string().min(1).max(10);
export const apartmentNumber = z.string().max(10).optional();
export const postalCode = z
  .string()
  .min(1)
  .max(10)
  .refine((value) => POSTAL_CODE_REGEX.test(value), {
    message: t("validation.postal_code.invalid_format"),
  });
